// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"16780588","265":"16780588","927":"16780588"}[chunkId] + ".chunk.css";
};